import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-neutral-950 py-10 text-neutral-400" data-id="element-68" data-mp="3gfiv8kpoaff6">
      <div className="mx-auto max-w-4xl px-4 sm:px-6" data-id="element-69" data-mp="32nul2myzi10u">
        <div className="grid gap-6 border-b border-neutral-800 pb-8 text-center sm:grid-cols-3 sm:text-left" data-id="element-70" data-mp="32p5qer82vgu2">
          <div className="flex flex-col items-center gap-1 sm:items-start" data-id="element-71" data-mp="36ppkflxcu4bz">
            <ZapIcon className="h-6 w-6 text-green-500" data-id="element-72" data-mp="3ug3c3bc12161" />
            <p className="text-sm font-semibold text-white" data-id="element-73" data-mp="38qz78i6g9vx">Acceso inmediato</p>
            <p className="text-xs" data-id="element-74" data-mp="36mr0ed8wopu">Recibís todo al mail al instante.</p>
          </div>
          <div className="flex flex-col items-center gap-1 sm:items-start" data-id="element-75" data-mp="3le2kov3h69ca">
            <LockIcon className="h-6 w-6 text-green-500" data-id="element-76" data-mp="3qc3zv4xs5oih" />
            <p className="text-sm font-semibold text-white" data-id="element-77" data-mp="29zgj5w4rykk0">Pago 100% seguro</p>
            <p className="text-xs" data-id="element-78" data-mp="2a1jkhcbdo041">Procesado con encriptación bancaria.</p>
          </div>
          <div className="flex flex-col items-center gap-1 sm:items-start" data-id="element-79" data-mp="2ew70emsbfm70">
            <ShieldCheckIcon className="h-6 w-6 text-green-500" data-id="element-80" data-mp="3la28msb12zu6" />
            <p className="text-sm font-semibold text-white" data-id="element-81" data-mp="3gb8wb37h9evl">Garantía 7 días</p>
            <p className="text-xs" data-id="element-82" data-mp="3v7gfc075ga9a">Te devolvemos el 100% sin preguntas.</p>
          </div>
        </div>

        <div className="mt-8 text-center text-xs leading-relaxed" data-id="element-83" data-mp="3q8wpvptckgc6">
          <p className="font-bold text-neutral-300" data-id="element-84" data-mp="3qaq0fg72zkpg">Air Fryer Argentina — MegaPack 250 Recetas</p>
          <p className="mt-2" data-id="element-85" data-mp="80xhs2coepgg">
            © {new Date().getFullYear()} Air Fryer Argentina. Todos los derechos
            reservados. Producto digital de acceso inmediato.
          </p>
          <p className="mt-2 text-neutral-600" data-id="element-86" data-mp="hs1wr22cqaba">
            Este sitio no forma parte de Facebook ni Meta Platforms, Inc. Los resultados
            pueden variar según cada persona.
          </p>
        </div>
      </div>
    </footer>;
}